import { render, staticRenderFns } from "./NewEventModal.html?vue&type=template&id=290cb588&scoped=true&"
import script from "./NewEventModal.vue?vue&type=script&lang=js&"
export * from "./NewEventModal.vue?vue&type=script&lang=js&"
import style0 from "./NewEventModal.scss?vue&type=style&index=0&id=290cb588&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290cb588",
  null
  
)

export default component.exports